<template>
  <div class="login">
    <div class="rb-form">
	<div class="title">江北区时空数据共享平台</div>
      <div class="login-content" v-if="!forgetFormShow && !registerFormShow">
        <!-- 账号密码登录 -->
        <div v-if="firstContent === 'form'" style="height: 425px">
          <!-- 扫码提示 -->
          <div class="right-top" @click="handleErweima()" v-if="canToggleEwm">
            <div class="erweima">
              <img th:src="@{imgs/digital-2.png}" src="../../assets/images/digital-2.png" alt="" />
            </div>
            <div class="white-bg"></div>
            <div v-if="toggleBg" class="toggle-bg"></div>
          </div>
          <div class="ewm-txt" v-if="canToggleEwm">扫码登录更安全</div>
          <div class="log-form" id="logForm" v-if="logFormShow">
            <h2 class="log-tit">账号登录</h2>
            <div class="input-view">
              <!-- 这里的 username，password 也不能改动，因为security帮我们校验的时候，就是用它来接受参数的-->
              <input type="text" name="username" v-model="username" placeholder="用户名" required="" autofocus="" />
            </div>
            <div class="input-view">
              <input
                :type="passwordType"
                id="password2"
                name="password2"
                v-model="password2"
                placeholder="密码"
                required=""
                :disabled="passwordDisabled2"
              />
              <input type="hidden" id="password" name="password" v-model="password" placeholder="密码" required="" />
              <span class="pw-eye" @click="changePw()">
                <img
                  class="img-eye"
                  th:src="@{imgsV2/icon-eye_close.png}"
                  :src="imgEyeSrc"
                  alt="show or hide password"
                />
              </span>
            </div>
            <div class="input-view">
              <input
                type="text"
                class="ver-input"
                name="verification"
                :disabled="passwordDisabled1"
                v-model="password1"
                placeholder="验证码"
                required=""
              />
              <button :disabled="verificationDisabled" id="verification" @click="onSlide">{{ verification }}</button>
            </div>
            <p style="font-size: 14px; text-align: center; color: #666" id="telephone" v-if="telephone">
              {{ telephone }}
            </p>
            <div style="height: 20px"></div>
            <input type="hidden" name="${_csrf.parameterName}" value="${_csrf.token}" />
            <el-button
              class="btn-log"
              type="primary"
              :loading="fullscreenLoading"
              :disabled="submitTag"
              @click="onSubmit"
              >登录</el-button
            >
            <el-button class="btn-reg" plain @click="registerFormShow = true" v-if="canApplyAccount">账号申请</el-button>
          </div>
        </div>

        <!-- 浙政钉扫码登录 -->
        <div v-if="firstContent === 'ewm'" id="erwemaContent">
          <div class="right-top" @click="handleAccountIcon()" v-if="canToggleEwm">
            <div class="erweima">
              <img th:src="@{imgs/digital-3.png}" src="../../assets/images/digital-3.png" alt="" />
            </div>
            <div class="white-bg"></div>
            <div v-if="toggleBg2" class="toggle-bg"></div>
          </div>
          <div
            v-if="fullscreenLoading"
            style="position: absolute; width: 100%; height: 100%; z-index: 3"
            v-loading.lock="fullscreenLoading"
          ></div>
          <iframe width="266" height="300" :src="iframeSrc" v-if="iframeSrc" frameborder="0"></iframe>

          <el-button class="btn-reg" plain @click="registerFormShow = true" v-if="canApplyAccount">账号申请</el-button>
        </div>
      </div>

      <!-- 忘记密码 -->
      <div v-else-if="forgetFormShow" class="login-content">
        <form name="forgetForm" id="forgetId" method="post" action="/admin/user/resetPassword">
          <h2 class="log-tit">忘记密码</h2>
          <div class="input-view">
            <input
              type="text"
              id="f_username"
              v-model="fUsername"
              :disabled="fUsernameDisabled"
              name="f_username"
              placeholder="用户名"
              required=""
              autofocus=""
            />
            <input
              type="hidden"
              id="for_username"
              v-model="forUsername"
              name="for_username"
              placeholder="用户名"
              required=""
            />
          </div>
          <div class="input-view">
            <input
              type="password"
              id="f_password2"
              :disabled="fPasswordDisabled2"
              name="f_password2"
              v-model="fPassword2"
              placeholder="新密码"
              required=""
            />
            <input
              type="hidden"
              id="newPassword"
              v-model="newPassword"
              name="newPassword"
              placeholder="密码"
              required=""
            />
          </div>
          <div class="input-view">
            <input
              type="password"
              id="f_password3"
              :disabled="fPasswordDisabled3"
              v-model="fPassword3"
              name="f_password3"
              placeholder="确认新密码"
              required=" /"
            />
            <input type="hidden" id="conpassword" name="conpassword" placeholder="密码" required="" />
          </div>
          <div class="input-view">
            <input id="code" name="code" placeholder="验证码" required="" />
            <button @click="forgetYzm(event)" id="f_verification" :disabled="fVerificationDisabled" class="forget-yzm">
              {{ fVerification }}
            </button>
          </div>
          <p style="padding-bottom: 20px; color: #666; text-align: center" v-if="fTelephone">{{ fTelephone }}</p>
          <div class="forget-btns">
            <span @click="handleCancel()" class="forget-cancel">取消</span>
            <input
              type="button"
              @click="forgetConfirm()"
              value="确 定"
              class="btn btn-lg btn-primary btn-block btn-log"
            />
            <!-- <button class="btn btn-lg btn-primary btn-block btn-log"></button> -->
          </div>
        </form>
      </div>

      <!-- 注册表单 -->
      <div v-else-if="registerFormShow" class="register-content">
        <form name="registerForm">
          <h2 class="log-tit">账号申请</h2>
          <div class="input-view">
            <input type="text" v-model="registerForm.personName" placeholder="姓名" />
          </div>
          <div class="input-view">
            <input type="text" v-model="registerForm.telephone" placeholder="手机号" />
          </div>
          <div class="input-view">
            <input type="text" v-model="registerForm.department" placeholder="所属部门/机构" />
          </div>
          <div class="register-btns">
            <el-button class="cancel" @click="handleCancel()">取消</el-button>
            <el-button class="submit" type="primary" @click="onRegister()">提交</el-button>
          </div>
        </form>
      </div>
    </div>

    <!-- <img class="rb-img" th:src="@{imgsV2/future/log-dian.png}" src="../../assets/images/future/log-dian.png"> -->

    <!-- 图片右滑验证 -->
    <div class="slideContainer_max" ref="slideContainer_max" v-show="isShowSlide">
      <div class="mask" v-show="isShowSlide" ref="mask"></div>
      <div class="slideContainer" v-show="isShowSlide" ref="slideContainer">
        <slider-verification
          v-show="isShowSlide"
          @offMask="offMask"
          @successVerify="successVerify"
          ref="sliderChild"
        ></slider-verification>
      </div>
    </div>

    <el-dialog :visible.sync="regResultVisible" width="30%" center>
      <el-result class="result" icon="success" title="提交成功" subTitle="审核通过后将以短信的方式告知"> </el-result>
    </el-dialog>
  </div>
</template>

<script>
import SliderVerification from "../SlideVerification";
//引入 https://blog.csdn.net/u010227042/article/details/129128802
import { JSEncrypt } from "jsencrypt";
import { getQueryString, httpPostSecret } from "@/utils/utils";
import axios from "axios";

export default {
  name: "digital-twin",
  components: {
    SliderVerification,
  },
  data() {
    return {
      isShowSlide: false,
      NONES: ["", undefined, null],
      username: undefined,
      password: undefined,
      password2: undefined,
      password1: undefined,
      passwordDisabled2: false,
      passwordDisabled1: false,
      forgetFormShow: false,
      submitTag: false,
      toggleBg: false,
      firstContent: this.$envData.firstContent, // ewm（浙政钉扫码登录）、form(账号密码登录)
      canToggleEwm: this.$envData.canToggleEwm === "true",
      canApplyAccount: this.$envData.canApplyAccount === "true",
      toggleBg2: false,
      passwordType: "password",
      imgEyeSrc: require("../../assets/images/icon-eye_close.png"),
      verificationDisabled: false,
      logFormShow: true,
      telephone: null,
      verification: "获取验证码",
      fVerification: "获取验证码",

      fUsername: undefined,
      fPassword2: undefined,
      fPassword3: undefined,
      newPassword: undefined,
      forUsername: undefined,
      fUsernameDisabled: false,
      fPasswordDisabled2: false,
      fPasswordDisabled3: false,
      fVerificationDisabled: false,
      fTelephone: null,
      iframeSrc: null,
      fullscreenLoading: false,
      registerFormShow: false,
      registerForm: {},
      regResultVisible: false,
    };
  },
  beforeDestroy() {},
  destroyed() {},
  created() {
    // 拼接iframe的src
    this.combineIframeSrc();

    //判断url是否包含sign
    const urlUsername = getQueryString("username");
    const sign = getQueryString("sign");
    if (urlUsername && sign) {
      console.log(urlUsername);
      console.log(sign);
      this.username = urlUsername;
      this.password = sign;
      this.submitTag = true;
      //控制password1不提交(不加密的密码)
      this.passwordDisabled2 = true;
      // $("#logForm").submit();
      this.confirm();
      this.passwordDisabled2 = false;
      return;
    }

    // 判断是否显示页面密码错误提示
    let getErr = window.location.search;
    if (getErr.startsWith("?error")) {
      const errorMessage = this.getParaByName("error");
      const err = decodeURIComponent(errorMessage);
      this.$message.error(err);
    }

    if (getErr.startsWith("?forgotError")) {
      this.handleForget();
      const errorMessage = this.getParaByName("forgotError");
      const fErr = decodeURIComponent(errorMessage);
      this.$message.error(fErr);
    }
    this.f_chooseInp();
  },
  mounted() {
    // 扫码成功后需要在页面中监听扫码结果
    window.addEventListener("message", async (event) => {
      if (!event.data || !event.data.code) return;
      const url = "/api/user/loginByZzd";
      let params = { code: event.data.code };
      this.fullscreenLoading = true;
      const res = await httpPostSecret(url, params);
      this.fullscreenLoading = false;
      this.nextResultStep(res);
    });
  },
  methods: {
    combineIframeSrc() {
      const envData = this.$envData;
      const url = `https://${envData.ding_url}/oauth2/auth.htm?response_type=code&client_id=${envData.ding_client_id}&redirect_uri=${envData.ding_redirect_uri}&scope=get_user_info&authType=QRCODE&embedMode=true`;
      this.iframeSrc = url;
    },
    //这个函数就是触发验证图片弹出来的,可以绑定给你想要触发的某个按钮
    refreshCode() {
      this.successVerify();
    },

    //验证成功或者手动时，关闭遮罩层
    offMask() {
      this.isShowSlide = false;
    },

    //右滑验证成功或者不成功逻辑
    successVerify(msg) {
      if (msg) {
        this.isShowSlide = false;
        this.resetCode();
        this.yzm();
      } else {
        this.isShowSlide = true;
        this.$refs.sliderChild.uploadSlideVerificationCode();
      }
    },

    //刷新验证码
    resetCode() {
      //这个验证码刷新具体看你项目的需要格式
    },

    handleErweima() {
      this.toggleBg = true;
      setTimeout(() => {
        this.toggleBg = false;
        this.firstContent = "ewm";
      }, 1000);
    },

    handleAccountIcon() {
      this.toggleBg2 = true;
      setTimeout(() => {
        this.toggleBg2 = false;
        this.firstContent = "form";
      }, 1000);
    },

    onSlide() {
      if (this.submitTag) {
        return true;
      }

      if (this.NONES.includes(this.username)) {
        this.$message.error("用户名不能为空");
        return false;
      }

      if (this.NONES.includes(this.password2)) {
        this.$message.error("密码不能为空");
        return false;
      }

      this.refreshCode();

      // const sliderObj = new SliderVerification('#sub', {
      //   successCallback: () => {
      //     this.yzm()
      //   }
      // });

      // sliderObj.showLayer();
      // return false
    },
    confirm() {},
    async onSubmit() {
      if (this.submitTag) {
        return true;
      }

      if (this.NONES.includes(this.username)) {
        this.$message.error("用户名不能为空");
        return false;
      }

      if (this.NONES.includes(this.password2)) {
        this.$message.error("密码不能为空");
        return false;
      }

      if (this.NONES.includes(this.password1)) {
        this.$message.error("验证码不能为空");
        return false;
      }

      this.submitTag = true;
      this.passwordDisabled1 = true;
      this.passwordDisabled2 = true;
      this.fullscreenLoading = true;

      const url = "/api/user/login";
      let params = { userName: this.username, password: this.password2, smsCode: this.password1 };
      const res = await httpPostSecret(url, params);
      this.fullscreenLoading = false;

      this.passwordDisabled1 = false;
      this.passwordDisabled2 = false;

      this.nextResultStep(res);
    },

    async onRegister() {
      if (this.NONES.includes(this.registerForm.personName)) {
        this.$message.error("姓名不能为空");
        return false;
      }

      if (this.NONES.includes(this.registerForm.telephone)) {
        this.$message.error("手机号不能为空");
        return false;
      } else {
        // 使用正则验证手机号格式
        const ref = /^1[3456789]\d{9}$/;
        if (!ref.test(this.registerForm.telephone)) {
          this.$message.error("手机号格式不正确");
          return false;
        }
      }

      if (this.NONES.includes(this.registerForm.department)) {
        this.$message.error("组织/机构不能为空");
        return false;
      }

      const url = "/api/user/accountApprove";
      const res = await axios.post(url, { ...this.registerForm }, { headers: { service: "resourcePlaning" } });
      this.fullscreenLoading = false;

      if (res.rspCode === "000000") {
        this.regResultVisible = true;
      } else {
        this.$message.error("服务异常，请稍后再试");
      }
    },

    nextResultStep(res) {
      if (res.rspCode === "000000") {
        const callback = getQueryString("callback");
        location.replace(callback || res.data);
      } else {
        this.$message.error(res.rspMsg);
        this.inputFocus();
      }
    },

    changePw() {
      if (this.passwordType === "password") {
        this.passwordType = "text";
        this.imgEyeSrc = require("../../assets/images/icon-eye_open.png");
      } else {
        this.passwordType = "password";
        this.imgEyeSrc = require("../../assets/images/icon-eye_close.png");
      }
    },

    // 获取验证码
    async yzm() {
      let time = 60;
      let timer = null;
      if (this.NONES.includes(this.username)) {
        return false;
      }
      this.verificationDisabled = true;
      const url = "/api/user/sendSms";
      let params = { username: this.username, password: this.password2, smsCode: this.password1 };
      console.log(358, params);
      const res = await httpPostSecret(url, params);
      this.fullscreenLoading = false;

      if (res.rspCode === "000000") {
        this.telephone = `请输入${res.data}收到的验证码`;
        timer = setInterval(() => {
          if (time > 0) {
            time -= 1;
            this.verification = time + "s";
          } else {
            this.verification = "获取验证码";
            this.verificationDisabled = false;
            clearInterval(timer);
          }
        }, 1000);
      } else {
        this.$message.error(res.rspMsg);
        this.verificationDisabled = false;
        this.verification = "获取验证码";
      }
    },
    inputFocus() {
      window.addEventListener("input", () => {
        this.submitTag = false;
      });
    },
    // chooseInp() {
    //     $("input").focus(function () {
    //         $(this).parents('div').addClass('b-blue');
    //         this.jErr = null //清空报错并隐藏报错提示栏
    //     }).blur(function () {
    //         $(this).parents('div').removeClass('b-blue');
    //         this.jErr = null
    //     });
    // },

    f_chooseInp() {
      // $("input").focus(function () {
      //   this.fErr = null
      // })
    },
    getParaByName(name) {
      var search = window.location.search;
      search = search.substr(1);
      if (typeof name === "undefined") return search;
      var searchArr = search.split("&");
      for (var i = 0; i < searchArr.length; i++) {
        var searchStr = searchArr[i];
        searchArr[i] = searchStr.split("=");
        if (searchArr[i][0] == name) {
          return searchStr.replace(name + "=", "");
        }
      }
      return "";
    },

    handleForget() {
      this.forgetFormShow = true;
      this.logFormShow = false;
    },

    handleCancel() {
      this.forgetFormShow = false;
      this.logFormShow = true;
      this.registerFormShow = false;
    },

    valideForget() {
      console.log("验证开始");

      if (this.NONES.includes(this.fUsername)) {
        this.$message.error("用户名不能为空");
        return false;
      }

      if (this.NONES.includes(this.fPassword2)) {
        this.$message.error("密码不能为空");
        return false;
      }

      if (this.NONES.includes(this.fPassword3)) {
        this.$message.error("确认密码不能为空");
        return false;
      }

      if (this.fPassword2 !== this.fPassword3) {
        this.$message.error("两次密码不一致");
        return false;
      }

      console.log("验证结束");
      return true;
    },

    forgetConfirm() {
      const flag = this.valideForget();
      console.log("验证结果", flag);
      if (!flag) return;

      const encrypt = new JSEncrypt();
      encrypt.setPublicKey(
        "-----BEGIN PUBLIC KEY-----" +
          "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCGXsxHtxVl/rcvs4ezSOlfAOswLv1vlx6TQxyR3DOaQ2Fi0C4UvtdVX3mqjzhtjqaWIFlgq5C4BrjArFzCA0HR+FOFDxsnKSKimv3k2gaYCWgbOAQLShmfe5SfYEbziUOyxyM6CAJvDujLAAWzfyUo1XTQUFFgP5tvD6CIwIZ4OwIDAQAB" +
          "-----END PUBLIC KEY-----"
      );
      const userPwdEncrypt = encrypt.encrypt(this.fPassword2);
      const userNameEncrypt = encrypt.encrypt(this.fUsername);
      this.newPassword = userPwdEncrypt;
      this.forUsername = userNameEncrypt;
      //控制password1不提交(不加密的密码)
      this.fUsernameDisabled = true;
      this.fPasswordDisabled2 = true;
      this.fPasswordDisabled3 = true;
      console.log("b");
      // $("#forgetId").submit();
      console.log("c");

      return false;
    },

    // 忘记密码 的 获取验证码
    forgetYzm(event) {
      event.preventDefault();
      // $('#verification').click(function (e){
      let time = 60;
      let timer = null;

      const flag = this.valideForget();
      if (!flag) return;

      this.fVerificationDisabled = true;
      const encrypt = new JSEncrypt();
      encrypt.setPublicKey(
        "-----BEGIN PUBLIC KEY-----" +
          "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCGXsxHtxVl/rcvs4ezSOlfAOswLv1vlx6TQxyR3DOaQ2Fi0C4UvtdVX3mqjzhtjqaWIFlgq5C4BrjArFzCA0HR+FOFDxsnKSKimv3k2gaYCWgbOAQLShmfe5SfYEbziUOyxyM6CAJvDujLAAWzfyUo1XTQUFFgP5tvD6CIwIZ4OwIDAQAB" +
          "-----END PUBLIC KEY-----"
      );
      var usernameEncrypt = encrypt.encrypt(this.fUsername);
      this.$http({
        contentType: "application/json",
        type: "POST",
        url: "/admin/user/sendSmsByForgot",
        data: JSON.stringify({ username: usernameEncrypt }),
        dataType: "json",
        success: function (data) {
          if (data.rspCode == "000000") {
            this.fTelephone = `已发送至${data.data}手机号`;
            timer = setInterval(function () {
              if (time > 0) {
                time -= 1;
                this.fVerification = time + "s";
              } else {
                this.fVerification = "获取验证码";
                this.fVerificationDisabled = false;
                clearInterval(timer);
              }
            }, 1000);
          } else {
            this.$message.error(data.rspMsg);
            this.fVerificationDisabled = false;
            this.fVerification = "获取验证码";
          }
        },
        error: function (data) {
          console.log(data);
          this.$message.error("发送验证码失败");
          this.fVerificationDisabled = false;
          this.fVerification = "获取验证码";
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../index.less";
@import "./styles.less";

.mask {
  position: fixed;
  left: 0%;
  top: 0%;
  width: 100%;
  height: 100%;
  z-index: 499;
  overflow: hidden;
  // background-color: rgba(218, 238, 255, 0.9);
}

.slideContainer {
  background: #fff;
  padding: 15px;
  position: fixed;
  left: 60%;
  // top: 21%;
  z-index: 999;
  box-shadow: 0 0 20px #aaa;
  border-radius: 8px;
}
</style>
